import axionIns from "./axios";

// A network/CORS failure has no `error.response`, which used to make this
// resolve to undefined and hide the real cause from callers.
const normalizeError = (error, url) => {
  if (error?.response) return error.response;

  // eslint-disable-next-line no-console
  console.error(`[api] ${url} failed:`, error?.message || error);

  return {
    status: 0,
    data: {
      message:
        error?.message === "Network Error"
          ? "Can't reach the API. Check the server is running and CORS allows this origin."
          : error?.message || "Request failed.",
    },
  };
};

const post = async (url, payload) => {
  return await axionIns
    .post(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return normalizeError(error, url);
    });
};

// As post(), but with no Authorization header - for the endpoints whose proof
// is in the body rather than in a session.
const postPublic = async (url, payload) => {
  return axionIns
    .post(url, JSON.stringify(payload), { skipAuth: true })
    .then((response) => response)
    .catch((error) => normalizeError(error, url));
};

const postFormData = async (url, formData) => {
  return axionIns
    .post(url, formData)
    .then((response) => response)
    .catch((error) => normalizeError(error, url));
};

const get = async (url, config = {}) => {
  return axionIns
    .get(url, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return normalizeError(error, url);
    });
};

const put = async (url, payload) => {
  return axionIns
    .put(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return normalizeError(error, url);
    });
};

const patch = async (url, payload) => {
  return axionIns
    .patch(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return normalizeError(error, url);
    });
};

const deleteApi = async (url, payload) => {
  return axionIns
    .delete(url, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return normalizeError(error, url);
    });
};

const exportObject = {
  post,
  postFormData,
  get,
  put,
  patch,
  deleteApi,
  postPublic,
};
export default exportObject;
